import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      profileData: 'player-profile/profile',
      contactsData: 'player-profile/contacts',
      parentsData: 'player-profile/parents',
      generalData: 'player-profile/general',
      actions: 'player-profile/profileActions',
      statsAthleticsData: 'player-profile/statsAthletics',
      statsPerformancesData: 'player-profile/statsPerformances'
    }),

    hasContactInformation() {
      let status = false;
      [
        'address',
        'city',
        'state',
        'country',
        'postal_code',
        'mobile_phone',
        'home_phone',
        'facebook',
        'twitter',
        'instagram',
        'email'
      ].forEach(field => {
        if (this.contactsData.hasOwnProperty(field)) {
          status = true;
        }
      });

      return status;
    },

    hasVideos() {
      return this.profileData.videos.hasOwnProperty('data')
        ? this.profileData.videos.data.length > 0
        : false;
    },

    hasBio() {
      return (
        !!this.profileData.bio && !!this.profileData.bio.metas[0].value.content
      );
    },

    hasAdditionalSports() {
      return this.profileData.additional_sports.length > 0;
    },

    hasTeams() {
      return this.profileData.teams.length > 0;
    },

    hasShowcase() {
      return this.profileData.showcases.length > 0;
    },

    hasTournaments() {
      return this.profileData.tournaments.length > 0;
    },

    hasAthletics() {
      return this.hasShowcase || this.hasTournaments || this.hasTeams || this.hasAdditionalSports;
    },

    hasStatsMetrics() {
      return this.actions
        ? this.actions.hasOwnProperty('putt')
          ? this.actions.putt.length > 0 || this.actions.swing.length > 0
          : this.actions.length > 0
        : false;
    },

    hasStatsAthletics() {
      return this.statsAthleticsData !== null;
    },

    hasStatsPerformances() {
      return this.statsPerformancesData !== null;
    },

    hasStats() {
      return (
        this.hasStatsMetrics ||
        this.hasStatsPerformances ||
        this.hasStatsAthletics
      );
    },

    isContactVisible() {
      return this.profileData.contacts.visible;
    },

    isParentsVisible() {
      return this.profileData.parents
        ? this.profileData.parents.visible
        : false;
    },

    hasParentContactInformation() {
      return this.parentsData.length > 0;
    },

    hasContactData() {
      return this.hasContactInformation && this.isContactVisible;
    },

    hasParentsData() {
      return this.isParentsVisible && this.hasParentContactInformation;
    },

    hasSummary() {
      return this.hasVideos || this.hasBio;
    },

    hasContacts() {
      return this.hasContactData || this.hasParentsData;
    },

    hasAcademics() {
      return this.profileData.educations.length > 0;
    },

    hasGeneralData() {
      let status = false;
      [
        'birth_date',
        'graduating_year',
        'graduating_school',
        'handicap',
        'height',
        'weight',
        'swings'
      ].forEach(field => {
        if (this.generalData.hasOwnProperty(field)) {
          status = true;
        }
      });

      return status;
    }
  }
};
